// extracted by mini-css-extract-plugin
export default {"readBloc":"Cgu_readBloc__DMQrF","cguDetails":"Cgu_cguDetails__ljLI4","smallLogo":"Cgu_smallLogo__H5qjg","select":"Cgu_select__QgccS","container":"Cgu_container__SEgWo"};